import React from "react";
import { Col, Card, CardBody } from "reactstrap";
import HeaderCard from "../../Common/Component/HeaderCard" ;

import { Line } from "react-chartjs-2";
import { lineChartOptions } from "./apexData";


const LineChartClass = ({
  statics
}) => {

const labels =statics.labels
const checkins=statics.checkins
const checkouts= statics.checkouts
const early_out_times= statics.early_out_times
const late_times = statics.late_times
  const lineChartData = {
    labels,
    datasets: [
      {
        label: "حضور متاخر",
        data:late_times,
        borderColor: "#d22d3d",
        backgroundColor: "#d22d3d",
      },
      {
        label: "الانصراف مبكرا",
        data:early_out_times,
        borderColor: "#e2c636",
        backgroundColor: "#e2c636",
      },
      {
        label: "الانصراف",
        data:checkouts,
        borderColor: "#ba895d",
        backgroundColor: "#ba895d",
      },
      {
        label: "الحضور",
        data: checkins,
        borderColor: "#24695c",
        backgroundColor: "#24695c",
      },
    ],
    plugins: {
      datalabels: {
        display: false,
        color: "white",
      },
    },
  };
  return (
    <Col  md="12" >
      <Card>
        <HeaderCard title="تحليل الحضور والانصراف" />
        <CardBody className="chart-block">
          <Line
            data={lineChartData}
            options={lineChartOptions}
            width={717}
            height={358}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default LineChartClass;
